import React, { Dispatch, SetStateAction } from "react";
import Navigator from '../components/Navigation';
import { ArticleTextSection } from "../articleDetailPage/ArticleTextSection"
import { ProtectedArticleGroup } from "../articleDetailPage/ProtectedArticleGroup";
import { ArticleTitle } from "../articleDetailPage/ArticleTitle";
import { hashPasswordsFromEnv } from "../utils/passwordUtils";
import ArticleImageLayout from "../articleDetailPage/ArticleImageLayout";
import '../style.css';
import { Wavedivider } from "../components/Wavedivider";
import { CalloutLink } from "../components/CalloutLink";
import { useMetaTags } from '../utils/useMetaTags';
import ProtectedPage from "../components/ProtectedPage";
import street1 from '../image/articles/히로시마/거리1.webp';
import street2 from '../image/articles/히로시마/거리2.webp';
import turtle from '../image/articles/히로시마/거북이.webp';
import greentea1 from '../image/articles/히로시마/녹차1.webp';
import greentea2 from '../image/articles/히로시마/녹차2.webp';
import playground from '../image/articles/히로시마/놀이터.webp';
import proteinbar1 from '../image/articles/히로시마/단백질바1.webp';
import fish from '../image/articles/히로시마/붕어.webp';
import mountain1 from '../image/articles/히로시마/산거1.webp';
import mountain2 from '../image/articles/히로시마/산거2.webp';
import mountain3 from '../image/articles/히로시마/산거3.webp';
import shopping1 from '../image/articles/히로시마/쇼핑1.webp';
import shopping2 from '../image/articles/히로시마/쇼핑2.webp';
import shopping3 from '../image/articles/히로시마/쇼핑3.webp';
import shukkeien1 from '../image/articles/히로시마/슈케이엔1.webp';
import shukkeien2 from '../image/articles/히로시마/슈케이엔2.webp';
import shukkeien3 from '../image/articles/히로시마/슈케이엔3.webp';
import shukkeien4 from '../image/articles/히로시마/슈케이엔4.webp';
import shukkeien5 from '../image/articles/히로시마/슈케이엔5.webp';
import shukkeien6 from '../image/articles/히로시마/슈케이엔6.webp';
import restaurant1 from '../image/articles/히로시마/식당1.webp';
import restaurant2 from '../image/articles/히로시마/식당2.webp';
import restaurant3 from '../image/articles/히로시마/식당3.webp';
import nightview1 from '../image/articles/히로시마/야경1.webp';
import nightview2 from '../image/articles/히로시마/야경2.webp';
import nightview3 from '../image/articles/히로시마/야경3.webp';
import atomicdome1 from '../image/articles/히로시마/원폭돔1.webp';
import atomicdome3 from '../image/articles/히로시마/원폭돔3.webp';
import atomicdome4 from '../image/articles/히로시마/원폭돔4.webp';
import whiskey from '../image/articles/히로시마/위스키.webp';
import coffee1 from '../image/articles/히로시마/커피1.webp';
import coffee2 from '../image/articles/히로시마/커피2.webp';


const imagesStreet = [street1, street2];
const imagesAtomicdome = [atomicdome1, atomicdome3, atomicdome4];
const imagesShukkeien = [shukkeien1, shukkeien2, shukkeien3, shukkeien4, shukkeien5, shukkeien6];
const imagesMountain = [mountain1, mountain2, mountain3];
const imagesNightview = [nightview1, nightview2, nightview3];
const imagesRestaurant = [restaurant1, restaurant2, restaurant3];
const imagesShopping = [shopping1, shopping2, shopping3];
const imagesCafe = [coffee1, coffee2, greentea1];
const imagesSnack = [greentea2, proteinbar1, whiskey];
const imagesAnimal = [turtle, fish, playground];

function Essay2606_hirosima(props: {
    activeNav: number, 
    setActiveNav: Dispatch<SetStateAction<number>>,
  }) {
   
      
      const hashedPasswords = hashPasswordsFromEnv(
        process.env.REACT_APP_ESSAY2606_PASSWORDS
      );
    
      useMetaTags({
        title: '여행기록 - Lynkim',
        description: '히로시마 여행기록',
        image: '/ogimage.png',
      });
      
      return (
        <>
        {/* <ProtectedPage password={hashedPasswords} description="이 페이지의 비밀번호는 개인번호로 설정되어 있어요"> */}
        <Navigator activeNav={props.activeNav} setActiveNav={props.setActiveNav} />
        <div className='fadeIn '>
            <ArticleTitle
                title={'여행기록'}
                titleEn={'Travel Journal'}
                description={<div>히로시마에 두고온 것</div>}
                descriptionEn={'Things I brought back from Hiroshima'}
                category={'essay'}
                date={'2026.06.07.'}
                thumbnail={street1}
            />
        </div>
        <Wavedivider/>
        <div className='articleLayout'>

            <ArticleTextSection
                title='몰래 떠나기'
                titleEn='Slipping Away'
                marginBottom={true}
                marginTop={true}
                description={<div>

                    </div>} />
            <ArticleImageLayout images={imagesStreet} />
            <ArticleImageLayout images={imagesAtomicdome} />
            <ArticleImageLayout images={imagesShukkeien} />
            <ArticleImageLayout images={imagesMountain} />
            <ArticleImageLayout images={imagesNightview} />

            <ArticleTextSection
                title='히로시마에 두고온 것'
                titleEn='Things I brought back from Hiroshima'
                marginBottom={true}
                marginTop={true}
                description={<div>
                  혼자일 때 느끼는 외로움
                    </div>} />
            <ArticleImageLayout images={imagesRestaurant} />
            <ArticleImageLayout images={imagesShopping} />
            <ArticleImageLayout images={imagesCafe} />
            <ArticleImageLayout images={imagesSnack} />
            <ArticleImageLayout images={imagesAnimal} />


        </div>
        {/* </ProtectedPage> */}
        </>
      )
  }

export default Essay2606_hirosima;